export type PrefixedRole =
  | 'ROLE_VIEW'
  | 'ROLE_EDIT'
  | 'ROLE_RULES_ADMIN'
  | 'ROLE_ADMIN'
  | 'ROLE_PLATFORM_ORG_MANAGE'
  | 'ROLE_PROTECT_EXCLUSIONS_MANAGE'
  | 'ROLE_PROTECT_POLICIES_MANAGE'
  | 'ROLE_VIEW_AUDIT_LOGS'

export const allPrefixedRoles: PrefixedRole[] = [
  'ROLE_VIEW',
  'ROLE_EDIT',
  'ROLE_RULES_ADMIN',
  'ROLE_ADMIN',
  'ROLE_PLATFORM_ORG_MANAGE',
  'ROLE_PROTECT_EXCLUSIONS_MANAGE',
  'ROLE_PROTECT_POLICIES_MANAGE',
  'ROLE_VIEW_AUDIT_LOGS'
]

export type Role =
  | 'VIEW'
  | 'EDIT'
  | 'RULES_ADMIN'
  | 'ADMIN'
  | 'PLATFORM_ORG_MANAGE'
  | 'PROTECT_EXCLUSIONS_MANAGE'
  | 'PROTECT_POLICIES_MANAGE'
  | 'VIEW_AUDIT_LOGS'

// RBAC permissions are not required to be added in this array
const rolesByLeastPermissive: Role[] = ['VIEW', 'EDIT', 'RULES_ADMIN', 'ADMIN']

const maxReducer = (a, b) => Math.max(a, b)

export function getMostPermissive(roles: PrefixedRole[]) {
  return rolesByLeastPermissive[
    roles
      .map((prefixedRole) => prefixedRole.slice(5) as Role)
      .map((role) => (role ? rolesByLeastPermissive.indexOf(role) : -1))
      .reduce(maxReducer, -1)
  ]
}
